module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('footer', {
    staticClass: "footer"
  }, [_c('div', {
    staticClass: "container"
  }, [_c('nav', [_c('p', {
    staticClass: "copyright text-center"
  }, [_vm._v("\n        © 2022 Raefton\n      ")])])])])
}]}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-42eb66c3"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/AppFooter.vue
// module id = 701
// module chunks = 0